import {TechnologicalOperationFormTemplate} from "./TechnologicalOperationFormTemplate";

export function TechnologicalOperationFormCreate() {

    return (
        <TechnologicalOperationFormTemplate buttonName={"Создать"}/>
    )
}